import { Button, Modal } from 'antd';
import { useState } from 'react';
import { ContainerFooter, Content, ModalContainer } from './styles';

import owlImg from '../../../../assets/img/pet/corujaProfessora.png';
import { apiNode } from '../../../../services/api';
import { useNavigate } from 'react-router-dom';

interface DeleteLeagueModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

export const DeleteLeagueModal = ({
  closeModal,
  isOpen,
}: DeleteLeagueModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleDeleteLeague = async () => {
    try {
      setIsLoading(true);
      const response = await apiNode.get('/ligas/users');

      if (!response.data.participante.isAdmin) {
        return;
      }

      const leagueId = response.data.liga.id;

      await apiNode.delete(`/ligas/${leagueId}`);

      navigate('/leagues');
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        bodyStyle={{ padding: 0 }}
        footer={[
          <ContainerFooter key="teste">
            <Button
              type="primary"
              onClick={handleDeleteLeague}
              loading={isLoading}
              disabled={isLoading}
              key="exitLeague"
            >
              Sim
            </Button>
            <Button
              type="primary"
              onClick={closeModal}
              disabled={isLoading}
              key="stayInLeague"
            >
              Não
            </Button>
          </ContainerFooter>,
        ]}
      >
        <Content>
          <h1>ATENÇÃO!</h1>

          <img src={owlImg} alt="Imagem de uma coruja" />

          <span>
            <p>Ao deletar a liga, todos os dados serão perdidos!</p>
            <p>Tem certeza que você deseja apagá-la?</p>
          </span>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
